import dashboard from './dashboardEtudiants';
import emailNotificationsPortailStudent from './emailNotificationsPortailStudent';
// import widget from './widget';
// import application from './applicationEcoles';
/* 
import cours from './coursEcoles';
import ConfigPaiements from './paiements/ConfigPaiements'; */
import etudiantsPortail from './etudiantsPortail';
/* import caisse from './caisse';
import professeurs from './professeurs'; */

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, emailNotificationsPortailStudent,  etudiantsPortail]
};

export default menuItems;
